import {createAsyncThunk} from '@reduxjs/toolkit';
import {OnlineChatService} from 'modules/online-chat/services/OnlineChatService';
import {actionSetIsOnlineChatLoading, onlineChatModuleName} from 'modules/online-chat/slice';

export const connectOnlineChat = createAsyncThunk(`${onlineChatModuleName}/connect`, async (_, {dispatch}) => {
    dispatch(actionSetIsOnlineChatLoading(true));
    await OnlineChatService.connect();
    dispatch(actionSetIsOnlineChatLoading(false));
});
